/** case:  Hikvision, NVR, High def */
function hikvisionNVRStreamHigh (address, port, number) {
  return `rtsp://${address}:${port}/Streaming/Channels/${number}01`
}
/** case: Hikvision, NVR, Low def */
function hikvisionNVRStreamLow (address, port, number) {
  return `rtsp://${address}:${port}/Streaming/Channels/${number}02`
}
/** case: Hikvision, IP, High def */
function hikvisionIPStreamHigh (address, port) {
  return `rtsp://${address}:${port}/Streaming/Channels/101`
}
/** case: Hikvision, IP, Low def */
function hikvisionIPStreamLow (address, port) {
  return `rtsp://${address}:${port}/Streaming/Channels/102`
}
/** case: Axis, IP/NVR, High def */
function axisStreamHigh (address, port) {
  return `rtsp://${address}:${port}//axis-media.amp?videocodec=h264&streamprofile=dwSpectrumPrimary`
}
/** case: Axis, IP/NVR, Low def */
function axisStreamLow (address, port) {
  return `rtsp://${address}:${port}//axis-media.amp?videocodec=h264&streamprofile=dwSpectrumSecondary`
}
/** case: UNV, IP, Low def */
function unvStreamLow (address, port, number) {
  return `rtsp://${address}:${port}/unicast/c${number}/s1/live`
}
/** case: TVI, IP, High def */
function tviStreamHigh (address, port, number) {
  return `rtsp://${address}:${port}/cam/realmonitor?channel=${number}&subtype=0`
}
export {
  hikvisionNVRStreamHigh,
  hikvisionNVRStreamLow,
  hikvisionIPStreamHigh,
  hikvisionIPStreamLow,
  axisStreamHigh,
  axisStreamLow,
  unvStreamLow,
  tviStreamHigh,
}
